var map = {
	"./placeholder-0.svg": 616,
	"./placeholder-1.svg": 617,
	"./placeholder-2.svg": 618,
	"./placeholder-3.svg": 619,
	"./placeholder-4.svg": 620,
	"./placeholder-5.svg": 621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 615;